import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Grid, Row, Col, Button} from 'react-bootstrap'
import DetailField from './detail-field';
import PpcUserForm from './ppc-user-form'
import BackLink from '../../../common/back-link/index'
import PageTitle from '../../../common/page-title/index'
import ArrowButton from '../../../common/button-arrow';
import IgniteDataTable from '../../../common/datatable/index';
import ConfirmPopup from '../../../common/confirm-popup';
import {dateFormat} from '../../../../utils/commonFunctions';
import {getPpcUser, getPpcUserLoads, cancelPpcUserLoad} from '../../../../actions/ppc'
import {history} from '../../../../store';

import './styles.css'

class PpcUser extends Component {

  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 1,
      delete:     {
        show: false
      }
    };

    this.columns = [
      {prop: 'created-at', title: 'Load date', format(data, row) {return dateFormat(data)}},
      {prop: 'points', title: 'Value (points)', width: '120'},
      {prop: 'value', title: 'Value (€)', width: '100'},
      {prop: 'load-type', title: 'Load type', width: '150'},
      {prop: 'status', title: 'Status', width: '150'},
    ];

    this.actions = [
      {
        label:    'Edit',
        disabled: (row) => row.attributes.status !== 'unprocessed',
        permissions: {
          action: "manage",
          subjectClass: "PpcUser",
        },
        callback: (row) => {
          history.push(`/admin/ppc/management/${this.id}/loads/${row.id}`);
        }
      },
      {
        label:    'Cancel',
        disabled: (row) => row.attributes.status !== 'unprocessed',
        callback: (row) => {
          this.setState({delete: {show: true, id: row.id}});
        }
      }
    ];
  }

  componentWillMount() {
    this.id = +this.props.match.params.id;
    this.props.dispatch(getPpcUser(this.id));
    this.props.dispatch(getPpcUserLoads(this.id));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_ppc.management.user'));
    this.props.dispatch({type: 'CLEAR_EDIT_PPC_USER'});
  }

  handlePageChange = (page, size) => {
    this.handleSearch();
    this.setState({pageNumber: page});
  };

  handleManualCardLoad = () => {
    history.push(`/admin/ppc/management/${this.id}/loads/new`);
  };

  handleCancel = (result) => {
    const id = this.state.delete.id;
    this.setState({delete: {show: false}});
    if (result) {
      this.props.dispatch(cancelPpcUserLoad(this.props.user.id, id));
    }
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="ppc-user">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/ppc/management"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="header">
              <PageTitle>{this.props.user ? (`${this.props.user.attributes['first-name']} ${this.props.user.attributes['last-name']}`) : '...'}
              </PageTitle>
              <ArrowButton submit={false}
                           arrow={false}
                           onClick={this.handleManualCardLoad}
                           permissions={{
                             action: "manual-load",
                             subjectClass: "PpcUser",
                           }}
                           className="pull-right">Manual prepaid card load</ArrowButton>
            </div>
          </Col>
        </Row>
        <Row className="loads-table">
          <Col lg={12}>
            <IgniteDataTable hideId={false}
                             data={this.props.loads}
                             columns={this.columns}
                             actions={this.actions}
                             pagination={this.props.pagination}
                             onPageChange={this.handlePageChange}
                             currentPage={this.state.pageNumber}/>

            {
              this.state.delete.show &&
              <ConfirmPopup header="CANCEL PREPAID CARD LOAD"
                            onClose={this.handleCancel}>
                <p>Are you sure you want to cancel this PPC load?</p>
              </ConfirmPopup>
            }
          </Col>
        </Row>
        <div className="user-details">
          <DetailField label="User ID">
            {this.props.user && this.props.user.id}
          </DetailField>
          <DetailField label="PPC account number">
            {this.props.user && this.props.user.attributes['account-number']}
          </DetailField>
          <DetailField label="Opt in date">
            {this.props.user && dateFormat(this.props.user.attributes['created-at'])}
          </DetailField>
        </div>
        {
          this.props.user && <PpcUserForm id={this.id} statuses={this.props.statuses}/>
        }
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    user:       state.ppc.user,
    statuses:   state.ppc.kycStatuses,
    loads:      state.ppc.loads.list,
    pagination: state.ppc.loads.paging,
    fetched:    state.ppc.fetched,
    fetching:   state.ppc.fetching,
  };
};

export default connect(mapStateToProps)(PpcUser);



// WEBPACK FOOTER //
// ./src/components/admin/ppc/user/index.jsx